import * as React from 'react'
import * as ReactDOM from 'react-dom'

export const getPortalRoot = () => document.getElementById('announcement-root')

interface AnnouncementPortalProps {
  className?: string
  children?: React.ReactNode | undefined
}

class AnnouncementPortal extends React.Component<AnnouncementPortalProps> {
  private el: HTMLDivElement
  constructor(props: AnnouncementPortalProps) {
    super(props)
    this.el = document.createElement('div')
  }

  public componentDidMount() {
    const portalRoot = getPortalRoot()
    if (portalRoot) {
      portalRoot.appendChild(this.el)
    }
  }
  public componentWillUnmount() {
    const portalRoot = getPortalRoot()
    if (portalRoot) {
      portalRoot.removeChild(this.el)
    }
  }

  public render(): any {
    const portalRoot = getPortalRoot()
    if (portalRoot) {
      return ReactDOM.createPortal(this.props.children, portalRoot)
    }
    return null
  }
}

export default AnnouncementPortal
